export function sortStringValues(
    array: any[],
    key?: string,
    caseSensitive: boolean = false,
) {
  array.sort((a, b) => {
    let aValue
    let bValue

    if (key === undefined) {
      aValue = a as string
      bValue = b as string
    } else {
      aValue = a[key] as string
      bValue = b[key] as string
    }

    if (!caseSensitive) {
      aValue = aValue.toLowerCase()
      bValue = bValue.toLowerCase()
    }

    if (aValue > bValue) {
      return 1
    }
    if (aValue < bValue) {
      return -1
    }
    return 0
  })
}

export function formatDateToDatePicker(selectedDate: string, splitCharacter: string) {
  let formattedDate: string | null = null
  if (selectedDate) {
    const [year, month, day] = selectedDate.split(splitCharacter)
    formattedDate = `${day}.${month}.${year}`
  }
  return formattedDate
}
